export enum AppType {
    CM = 'CM',
    Admin = 'Admin',
}
